import { useEffect, useState } from 'react'
import {
    ScoopTextField,
    ScoopText,
    ScoopSelector,
    ScoopMenu,
    ScoopMenuDivider,
    ScoopCheckbox,
    ScoopRow,
    ScoopColumn,
} from '../../../../../ui'
import styles from './FilterModal.module.scss'

const FilterModal = ({
    columnName,
    open,
    menuItems,
    anchorEl,
    id,
    setOperator,
    operator,
    setChanges,
    allValues,
    operatorValues,
    setOperatorValues,
    filterList,
    saveFilter2,
}) => {
    //Variables for managing the search input
    const [filterSearch, setFilterSearch] = useState('')
    const [tempAllValues, setTempAllValues] = useState([])

    //Contains the current filter list with all the filter objects
    const [currentFilterList, setCurrentFilterList] = useState(
        filterList?.filter((f) => f.attributeName === columnName) ?? []
    )
    const [currentOperatorValues, setCurrentOperatorValues] = useState(operatorValues)

    useEffect(() => {
        setTempAllValues(allValues)
    }, [allValues])

    useEffect(() => {
        setCurrentFilterList(filterList?.filter((f) => f.attributeName === columnName) ?? [])
    }, [filterList])

    const addSelectedValue = (value) => {
        setChanges(true)
        // Check if there exists a filter with the same operator
        const existingFilterIndex = currentFilterList.findIndex((f) => f.operator === operator)
        if (existingFilterIndex !== -1) {
            // If the value is already in the filter list, remove it
            const existingFilter = currentFilterList[existingFilterIndex]
            if (existingFilter.filterValue.values.includes(value)) {
                setCurrentFilterList((prev) => {
                    const updatedFilterList = [...prev]
                    const updatedFilter = {
                        ...existingFilter,
                        filterValue: {
                            values: existingFilter.filterValue.values.filter((v) => v !== value),
                        },
                    }
                    // If the values array becomes empty, remove the entire filter
                    if (updatedFilter.filterValue.values.length === 0) {
                        updatedFilterList.splice(existingFilterIndex, 1)
                    } else {
                        updatedFilterList[existingFilterIndex] = updatedFilter
                    }
                    return updatedFilterList
                })
            } else {
                // Otherwise, add the value to the existing filter
                setCurrentFilterList((prev) =>
                    prev.map((f) => {
                        if (f.operator === operator) {
                            return {
                                ...f,
                                filterValue: {
                                    values: [...f.filterValue.values, value],
                                },
                            }
                        }
                        return f
                    })
                )
            }
        } else {
            // If no filter with the current operator exists, create a new filter object with the value
            setCurrentFilterList((prev) => [
                ...prev,
                {
                    attributeName: columnName,
                    operator: operator,
                    filterValue: {
                        values: [value],
                    },
                },
            ])
        }
    }

    const addOperatorValues = (value) => {
        setChanges(true)
        if (currentOperatorValues.includes(value)) {
            setOperatorValues((prev) => prev.filter((v) => v !== value))
            setCurrentOperatorValues((prev) => prev.filter((v) => v !== value))
            setCurrentFilterList((prev) => prev.filter((f) => f.operator !== value))
        } else {
            setOperatorValues([...operatorValues, value])
            setCurrentOperatorValues([...currentOperatorValues, value])
            setCurrentFilterList((prev) => {
                const existingFilterIndex = prev.findIndex((f) => f.operator === value)
                if (existingFilterIndex !== -1) {
                    return prev
                }
                return [
                    ...prev,
                    {
                        attributeName: columnName,
                        operator: value,
                        filterValue: {
                            values: [],
                        },
                    },
                ]
            })
        }
    }

    const handleFilterSearch = (e) => {
        setFilterSearch(e.target.value)
        setTempAllValues(
            allValues.filter((value) => value.toLowerCase().includes(e.target.value.toLowerCase()))
        )
    }

    return (
        <ScoopMenu
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={() => {
                saveFilter2(currentFilterList)
            }}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
            className={styles.menu}
        >
            <ScoopRow className={styles.header}>
                <ScoopText className={styles.columnName}>{columnName}</ScoopText>
                <div className={styles.selectorWrapper}>
                    <ScoopSelector
                        value={operator}
                        size={'small'}
                        className={styles.selector}
                        options={menuItems}
                        onChange={(event) => {
                            setOperator(event.target.value)
                            setChanges(true)
                        }}
                    />
                </div>
            </ScoopRow>

            <ScoopMenuDivider className={styles.divider} />
            <ScoopColumn className={styles.content}>
                {(operator === 'Equals' || operator === 'NotEquals') && (
                    <>
                        <ScoopRow className={styles.searchContainer}>
                            <div className={styles.customInput}>
                                <ScoopTextField
                                    onChange={handleFilterSearch}
                                    value={filterSearch}
                                    placeholder={'Search'}
                                    padding={'0px 8px'}
                                    className={styles.searchInputWrapper}
                                />
                            </div>
                        </ScoopRow>
                        {tempAllValues
                            .filter((v) => v !== 'NULL')
                            .map((value, index) => (
                                <ScoopRow key={index} className={styles.valueItem}>
                                    <ScoopCheckbox
                                        checked={currentFilterList
                                            .filter((f) => f.operator === operator)
                                            .some((f) => f.filterValue.values.includes(value))}
                                        className={styles.checkbox}
                                        onChange={() => addSelectedValue(value)}
                                        size="sm"
                                    />
                                    <ScoopText className={styles.valueText}>{value}</ScoopText>
                                </ScoopRow>
                            ))}
                    </>
                )}
                {(operator === 'IsNull' || operator === 'IsNotNull') && (
                    <ScoopRow className={styles.valueItem}>
                        <ScoopCheckbox
                            checked={currentOperatorValues.includes(operator)}
                            className={styles.checkbox}
                            onChange={() => addOperatorValues(operator)}
                            size="sm"
                        />
                        <ScoopText className={styles.valueText}>
                            {menuItems.find((m) => m.value === operator)?.label}
                        </ScoopText>
                    </ScoopRow>
                )}
            </ScoopColumn>
        </ScoopMenu>
    )
}

export default FilterModal
